import styled from "styled-components";
import {hexToRgba} from "../../../../themes/hex-to-rgba";

export const VideoErrorContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 1.4em;
    position: fixed;
    height: 100%;
    width: 100%;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    background: ${({theme}) => hexToRgba(theme.colors.background.toString(), 0.7)};
`;